<template>
    <el-dialog title="绑定店铺" :visible.sync="dialogTableVisible" width="40%">
        <el-row class="border-bottom padding">
            <el-col :span="24" class="line-height padding">
                <el-col :span="15">
                    <el-input v-model="search" placeholder="搜索店铺名称"></el-input>
                </el-col>
                <el-col :span="5" :offset="1">
                    <el-button type="primary" @click="createClick()">搜索</el-button>
                </el-col>
            </el-col>
        </el-row>
        <el-table
            ref="multipleTable"
            tooltip-effect="dark"
            :data="tableData"
            @selection-change="handleSelectionChange"
            border
            style="width: 100%;"
        >
            <el-table-column type="selection" width="55" align="center"></el-table-column>
            <el-table-column prop="binding" label="是否已绑定信用卡" align="center">
                <template slot-scope="scope">
                    <p>{{scope.row.isHasString}}</p>
                </template>
            </el-table-column>
            <el-table-column label="店铺名称" align="center">
                <template slot-scope="scope">
                    <p>{{scope.row.shop_name}}</p>
                </template>
            </el-table-column>
            <el-table-column label="商户ID" align="center">
                <template slot-scope="scope">
                    <p>{{scope.row.sellerId}}</p>
                </template>
            </el-table-column>
            <el-table-column label="站点" align="center">
                <template slot-scope="scope">
                    <el-collapse v-for="(ele,i) in scope.row.countryMarks" :key="i">
                        <template>
                            <p>{{ele.countryName}}</p>
                        </template>
                    </el-collapse>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            style="margin-top: 16px; text-align:right;"
            layout="total, sizes, prev, pager, next, jumper"
            :page-sizes="[10, 50, 100, 250]"
            :page-size="pagesize"
            :current-page="currentpage"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
        ></el-pagination>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogTableVisible = false">取 消</el-button>
            <el-button type="primary" @click="save">保存</el-button>
            <el-button @click="toggleSelection([tableData[1]])">切换</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { ajaxPost, Baseurl } from "../../../../api/api/api";
export default {
    name: "Boundshop",
    data() {
        return {
            search: "",
            dialogTableVisible: false,
            currentpage: 1,
            pagesize: 10,
            total: 0,
            tableData: [],
            list: [],
            ShopId: [],
            sellerData: "",
            isHas: "",
            multipleSelection: ""
        };
    },
    mounted() {},
    created() {},
    methods: {
        init(e) {
            this.dialogTableVisible = true;
            (this.sellerData = e),
                // console.log(this.sellerData)
                (this.isHas = e.sellerIds);
            this.createClick();
        },

        createClick() {
            var role = JSON.parse(window.localStorage.getItem("role"));
            var parameter = {
                sellerIds: this.sellerData.sellerIds,
                page: "1",
                size: "100",
                shop_name: this.search,
                company_id: role.company_id
            };
            ajaxPost(
                Baseurl + "sellerController/selectAllSeller",
                parameter
            ).then(res => {
                this.tableData = res.data.data.list;
                this.search = "";
            });
        },
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            if (columnIndex < 4) {
                if (row.span_num > 0) {
                    return {
                        rowspan: row.span_num,
                        colspan: 1
                    };
                } else {
                    return {
                        rowspan: 0,
                        colspan: 0
                    };
                }
            }
        },
        initselect() {
            this.toggleSelection(this.tableData[0]);
            //setTimeout(() => {

            // for(var i=0;i<this.tableData.length;i++){
            //   if(this.tableData[i].isHasString=='已绑定'){
            //     this.toggleSelection(1)
            //     console.log(i)
            //   }
            // }
            // }, 500);
        },
        toggleSelection(rows) {
            if (rows) {
                rows.forEach(row => {
                    this.$refs.multipleTable.toggleRowSelection(row);
                });
            } else {
                this.$refs.multipleTable.clearSelection();
            }
        },
        handleSelectionChange(val) {
            this.multipleTable = val;
        },
        save() {
            for (var i = 0; i < this.multipleTable.length; i++) {
                this.ShopId.push({ id: this.multipleTable[i].id });
            }
            var obj = {
                id: this.sellerData.id,
                sellers: this.ShopId
            };
            console.log(obj);
            ajaxPost(
                Baseurl + "creditCardController/creditCardBingSeller",
                obj
            ).then(res => {
                if (res.data.code == 200) {
                    this.$message({
                        type: "success",
                        message: "绑定店铺成功"
                    });
                    this.$emit("refresh");
                } else {
                    this.$message.error("绑定店铺失败");
                }
            });
            this.ShopId = [];
            this.dialogTableVisible = false;
        },
        handleSizeChange() {},
        handleCurrentChange() {}
    }
};
</script>

<style lang="scss" scoped>
/deep/ {
    .el-dialog__body {
        padding: 13px 20px;
    }
}
.line-height {
    line-height: 30px;
}
.padding {
    padding: 5px 0;
}
</style>